import React from "react";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "../mock/mock";

const WhatsAppFloating = () => {
  return (
    <a
      href={buildWhatsAppLink("Bonjour, je souhaite avoir des informations sur vos excursions.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacter sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 animate-ping" />
      <span className="relative flex items-center justify-center h-16 w-16 rounded-full bg-[#25D366] shadow-2xl shadow-[#25D366]/40 ring-4 ring-white transition-transform duration-200 group-hover:scale-110">
        <MessageCircle className="h-8 w-8 text-white" fill="white" strokeWidth={0} />
      </span>
      <span className="absolute right-20 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-lg bg-white px-3 py-2 text-sm font-semibold text-[#0B2545] shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200">
        Réserver sur WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppFloating;
